import ComponentHelper from '../../../../supers/ComponentHelper';
import React from 'react';
import './script-help.css';

class ScriptHelp extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			open: false
		};
		this.autoBind(['toggleHelp']);
	}

	toggleHelp() {
		this.setData('open', !this.data.open);
	}

	render() {
		let { className, type } = this.props;
		let { open } = this.data;
		return (
			<div className={`script-help-cmp ${className ? className : ''}`}>
				<div className="hbox hright">
					<div className="help-toggle hbox vcenter" onClick={this.toggleHelp}>
						{open ? <i className="mdi mdi-close-circle-outline" /> : <i className="mdi mdi-help-circle-outline" />}
						{open ? 'Hide help' : 'Show help'}
					</div>
				</div>
				<div className={`help-content shadow animated ${open ? 'fadeIn' : 'hidden fadeOut'}`}>
					{type === 'preScript' && (
						<div>
							<h3>Function arguments</h3>
							<table className="table">
								<thead>
									<tr>
										<th>Argument</th>
										<th>Description</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<code>config</code>
										</td>
										<td>
											A JavaScript object representing the endpoint configuration. The values of each property are the result of shallow-merging the
											connection configuration object, the endpoint configuration object, and the request body configuration object, in this order of
											precedence. Any template parameter present in the merged configuration will be replaced by the values provided on the request.
										</td>
									</tr>
									<tr>
										<td>
											<code>ctx</code>
										</td>
										<td>A JavaScript object containing data from the request.</td>
									</tr>
									<tr>
										<td>
											<code>ctx.request</code>
										</td>
										<td>A JavaScript object containing the request data.</td>
									</tr>
									<tr>
										<td>
											<code>ctx.request.headers</code>
										</td>
										<td>A JavaScript object containing the request headers.</td>
									</tr>
								</tbody>
							</table>

							<h3 className="m-t">Function response</h3>
							<p>The hook response should be an object with the next structure:</p>
							<table className="table">
								<thead>
									<tr>
										<th>Type</th>
										<th>Description</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Object</td>
										<td>A JavaScript config object of shape required by the specific connector.</td>
									</tr>
								</tbody>
							</table>

							<h3 style={{ marginTop: '1.5em' }}>Pre-hook example</h3>
							<pre className="sintax-hightlighter-box">
								{`/**
 * Connection config:
 * {
 *   foo: 'connection foo'
 * }
 *
 * Endpoint config:
 * {
 *   foo: 'endpoint foo',
 *   bar: 'endpoint $(myparam)'
 * }
 *
 * Request config:
 * {
 *   foo: 'request foo',
 *   bar: 'request bar',
 *   baz: 'request baz'
 * }
 *
 * Request parameters:
 * {
 *   myparam: 'somevalue'
 * }
 */

function prehook (config, ctx) {
  // config === {
  //   foo: 'connection foo',
  //   bar: 'endpoint somevalue',
  //   baz: 'request baz'
  // }

  let newConfig;

  // any function body to build a newConfig...

  return newConfig;
}`}
							</pre>
							<h3 className="m-t">Available JavaScript modules</h3>
							<p>The following JavaScript modules can be required and used inside your hook.</p>
							<h5 className="m-t-md">Lodash</h5>
							<p>
								Lodash is a JavaScript utility library that takes the hassle out of working with arrays, numbers, objects, strings, etc. It can be
								accessed using:
							</p>
							<pre className="sintax-hightlighter-box m-t">var _ = require('lodash');</pre>
							<p>
								<a rel="noopener noreferrer" href="https://lodash.com/docs" target="_blank">
									More Lodash documentation
								</a>.
							</p>
						</div>
					)}
					{type === 'postScript' && (
						<div>
							<p>
								This function is called after receiving the response from the external service. Allows you to intercept and modify the response object
								in any way you want.
							</p>

							<pre className="sintax-hightlighter-box">{'function posthook (response, ctx) {\n  return response;\n}'}</pre>

							<h3 style={{ marginTop: '1.5em' }}>Function arguments</h3>
							<table className="table">
								<thead>
									<tr>
										<th>Argument</th>
										<th>Type</th>
										<th>Description</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<code>response</code>
										</td>
										<td>Object</td>
										<td>Contains the response from the external service.</td>
									</tr>
									<tr>
										<td>
											<code>response.status</code>
										</td>
										<td>Integer</td>
										<td>The status code of the service response.</td>
									</tr>
									<tr>
										<td>
											<code>response.body</code>
										</td>
										<td>Object</td>
										<td>The body of the service response.</td>
									</tr>
									<tr>
										<td>
											<code>response.headers</code>
										</td>
										<td>Object</td>
										<td>The headers of the service response.</td>
									</tr>
									<tr>
										<td>
											<code>ctx</code>
										</td>
										<td>Object</td>
										<td>A JavaScript object containing data from the request.</td>
									</tr>
									<tr>
										<td>
											<code>ctx.request</code>
										</td>
										<td>Object</td>
										<td>A JavaScript object containing the request data.</td>
									</tr>
									<tr>
										<td>
											<code>ctx.request.headers</code>
										</td>
										<td>Object</td>
										<td>A JavaScript object containing the request headers.</td>
									</tr>
								</tbody>
							</table>

							<h3 className="m-t">Function response</h3>
							<p>The hook can return any data shape required by your endpoint contract.</p>
							<h3 className="m-t">Available JavaScript modules</h3>
							<p>The following JavaScript modules can be required and used inside your hook.</p>
							<h5 className="m-t-md">Lodash</h5>
							<p>
								Lodash is a JavaScript utility library that takes the hassle out of working with arrays, numbers, objects, strings, etc. It can be
								accessed using:
							</p>
							<pre className="sintax-hightlighter-box m-t">var _ = require('lodash');</pre>
							<p>
								<a rel="noopener noreferrer" href="https://lodash.com/docs" target="_blank">
									More Lodash documentation
								</a>.
							</p>
							<h5 className="m-t-md">Cheerio</h5>
							<p>
								Cheerio is a fast, flexible, and lean implementation of core jQuery designed specifically for the server. It can be accessed using:
							</p>
							<pre className="sintax-hightlighter-box m-t">var cheerio = require('cheerio');</pre>
							<p>
								<a rel="noopener noreferrer" href="https://cheerio.js.org/" target="_blank">
									More cheerio documentation
								</a>.
							</p>
							<h5 className="m-t-md">CSV parser</h5>
							<p>This module is a parser converting CSV text input into arrays or objects using a synchronous API. </p>
							<p>Example usage:</p>
							<pre className="sintax-hightlighter-box m-t">
								{`function posthook (response) {
  var parse = require('csv-parse/lib/sync');

  var options = {
    skip_empty_lines: true,
    relax_column_count: true,
    columns: true,
    delimiter: ';',
    quote: '',
    auto_parse: true
  };

  var parsedValues = parse(response.body.result, options);

  return parsedValues;
}`}
							</pre>
							<p>
								<a rel="noopener noreferrer" href="http://csv.adaltas.com/parse/#synchronous-api" target="_blank">
									More csv-parse documentation
								</a>.
							</p>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default ScriptHelp;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/integration-endpoint-form/script-help/ScriptHelp.js